import { reduxKey } from './constants';
import { CommentReaction, } from './types';
export var getCommentState = function (commentId) { return function (state) {
    return (commentId && state[reduxKey][commentId]) || {};
}; };
export var isInitialized = function (commentId) { return function (state) {
    return commentId &&
        state[reduxKey] !== undefined &&
        state[reduxKey][commentId] !== undefined;
}; };
export var isFeatured = function (commentId) { return function (state) {
    return getCommentState(commentId)(state)['isFeatured'];
}; };
export var isLiked = function (commentId) { return function (state) {
    return getCommentState(commentId)(state)['isLiked'];
}; };
export var isHidden = function (commentId) { return function (state) {
    return getCommentState(commentId)(state)['isHidden'];
}; };
export var isSpam = function (commentId) { return function (state) {
    return getCommentState(commentId)(state)['isSpam'];
}; };
export var getLikes = function (commentId) { return function (state) {
    return getCommentState(commentId)(state)['likes'];
}; };
export var isCommentReduxReady = function (state) { return !!state[reduxKey]; };
export function getCommentsByUser(state, userId) {
    var _a;
    var comments = state[reduxKey];
    var commentsByUser = [];
    for (var commentId in comments) {
        var comment = state[commentId];
        if (((_a = comment === null || comment === void 0 ? void 0 : comment.user) === null || _a === void 0 ? void 0 : _a.userId) === userId) {
            commentsByUser.push(comment);
        }
    }
    return commentsByUser;
}
export var getCommentReactions = function (state, comment) {
    var _a;
    var _b, _c, _d;
    var stateSlice = (_b = state[reduxKey]) !== null && _b !== void 0 ? _b : {};
    var reactions = (_c = stateSlice['reactions']) !== null && _c !== void 0 ? _c : {};
    if (!reactions[comment.commentId] && comment.likes > 0) {
        return _a = {},
            _a[CommentReaction.Like] = true,
            _a;
    }
    return (_d = reactions[comment.commentId]) !== null && _d !== void 0 ? _d : {};
};
//# sourceMappingURL=selectors.js.map